export const DATA_TEST_IDS = {
  INPUT: (elementId: string) => `${elementId}_input`,
  LIST: (elementId: string) => `${elementId}_list`,
  DRAG_HANDLE: (elementId: string, itemId: string) => `drag_handle_${elementId}_${itemId}`,
};
